<template>
     <li class="nav-item mr-75 n-hide">
        <a class="nav-link" :href="$routing('pannier')">
            <i class="ficon" style="color: #FFFFFF" data-feather="shopping-cart"></i>
            <span class="badge badge-pill badge-danger badge-up cart-item-count">{{ count }}</span>
        </a>
    </li>
</template>

<script>
    import { EventBus } from '../../helpers/shared'
    export default {
        name: "index",
        data: () => ({
            baskets: [],
            count: 0
        }),
        mounted() {
            //const element = JSON.parse(localStorage.getItem('carts'));
            let carts = this.$storage.getItem('carts');
            if (typeof carts !== 'undefined'){
                const element = JSON.parse(this.$storage.decryptString(this.$storage.getItem('carts')))
                if (Array.isArray(element)){
                    this.baskets = element;
                    this.count = this.baskets.length;
                }
            }else{
                this.$storage.setItem('carts',this.$storage.encryptString(JSON.stringify([])))
            }
            EventBus.$on('remove', this.removeBasket);
            EventBus.$on('addBasket', this.addBasket);
        },
        methods:{
            removeBasket() {
                this.count --;
            },
            addBasket() {
                this.count ++;
            }
        }
    }
</script>

<style scoped>

</style>
